import { MessageType } from '../../enums/message-type';
import { WebViewMessage } from './web-view-message';

export class ResizeCurrentWindowMessage extends WebViewMessage {
  public constructor(
    public width: number | undefined,
    public height: number | undefined,
  ) {
    super(MessageType.ResizeCurrentWindow);
  }
}
